import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/blog/read-our-consultants-article-on-the-impact-of-eu-ivdr-on-clinical-trials")({
  head: () => buildRouteHead("/es/blog/read-our-consultants-article-on-the-impact-of-eu-ivdr-on-clinical-trials", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ href: "/es/blog/impacto-de-eu-ivdr-en-ensayos-clinicos", replace: true });
  },
});
